import { defineMessages } from 'react-intl';

export default defineMessages({
  authRoles: 'Roles & permissions',
  permissions: 'Permissions',
  visible: 'Visible to users',

  // Actions
  editRole: 'Edit role',
  createRole: 'New role',
});
